module.exports = __webpack_public_path__ + "img/5.48139e49.jpg";